export enum FuelInterface {
    COMDATA = "C",
    EFS = "H",
    MULTISERVICE = "M",
    FLEETONE = "A",
    TA_TRAVEL_CENTERS = "B",
    GAS_BOY = "G",
    COMPASS = "O",
    PETROVEND = "P",
    QUIKO = "Q",
    TCHEK = "T",
    USBANK = "U",
    RELAY = "R",
    MOTIVE = "V",
}

export default FuelInterface;
